import { Button, Modal, Input, Upload } from "antd";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { updateAccountDetails } from "Sdk/Actions";
import {
  getUserDetailsFromReducer,
  getUserNameFromReducer,
} from "Store/reducers/Auth/AuthSlice";

const SeoFunction = ({ isOpen, onClose }) => {
  const [isLiveAdvnacedSEo, setisLiveAdvnacedSEo] = useState(true);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    keywords: "",
    author: "",
    ogTitle: "",
    ogDescription: "",
    ogImage: "",
    ogURL: "",
    twitterCard: "",
    twitterTitle: "",
    twitterDescription: "",
    twitterImage: "",
  });

  const userName = useSelector(getUserNameFromReducer);
  const userDetails = useSelector(getUserDetailsFromReducer);
  const [touched, setTouched] = useState({});

  console.log(userDetails, "userDetails-seo");

  useEffect(() => {
    let seo = userDetails?.advancedseo;
    try {
      let data = JSON.parse(seo);
      console.log(data, "parsedata");
    } catch (error) {
      console.log(error);
    }
  }, [userDetails]);

  const handleUpdateSeoData = async () => {
    console.log("function called");

    try {
      console.log("function called");
      if (formData) {
        let seoStringified = JSON.stringify(formData);
        const userData = {
          username: userName,
          advancedseo: seoStringified,
        };
        await updateAccountDetails(userData);
      } else {
        console.log("formData not found");
      }
      console.log("Changes saved!");
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => {
      const updated = { ...prev, [field]: value };
      if (!touched[field]) {
        if (field === "title") {
          updated.ogTitle = updated.twitterTitle = value;
        }
        if (field === "description")
          updated.ogDescription = updated.twitterDescription = value;
        if (field === "ogImage") updated.twitterImage = value;
      }
      return updated;
    });
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  return (
    <Modal open={isOpen} onCancel={onClose} footer={null} width={600} centered>
      {isLiveAdvnacedSEo ? (
        <div>Advance SEO Comming Soon...</div>
      ) : (
        <div className="p-6 flex flex-col justify-between h-[80vh]">
          <h2 className="text-xl font-semibold mb-4">Advanced SEO Settings</h2>
          <div className="max-h-full overflow-y-auto space-y-3 flex-1">
            {Object.keys(formData).map((key) => (
              <div key={key} className="flex flex-col">
                <label className="text-sm font-medium capitalize">
                  {key.replace(/([A-Z])/g, " $1").trim()}
                </label>
                {key.includes("Image") || key === "twitterCard" ? (
                  <Upload
                    beforeUpload={() => false}
                    onChange={(info) => handleChange(key, info.file.name)}
                    showUploadList={false}
                  >
                    <Button>Upload Image</Button>
                  </Upload>
                ) : (
                  <Input
                    type={key === "ogURL" ? "url" : "text"}
                    value={formData[key]}
                    onChange={(e) => handleChange(key, e.target.value)}
                    className="border border-gray-500 p-2  rounded-md"
                  />
                )}
              </div>
            ))}
          </div>
          <div className="flex justify-end mt-4 space-x-2">
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={handleUpdateSeoData}>
              Save
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default SeoFunction;
